"use strict";
var $ = require("../internals/export");
var toObject = require("../internals/to-object");
var lengthOfArrayLike = require("../internals/length-of-array-like");
var toIntegerOrInfinity = require("../internals/to-integer-or-infinity");
var addToUnscopables = require("../internals/add-to-unscopables");
$({ target: "Array", proto: true }, {
  at: function at(index) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? void 0 : O[k];
  }
});
addToUnscopables("at");
